import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import Testimonial from "./Testimonial";
import { IOffer } from "./Types";

function HowWeProtect(props: { offer: IOffer }) {
    const history = useHistory();
    const location = useLocation();
    const pageURL = window.location.origin;
    const routeToOfferPage = () => {
        let offerPagePath = "/sales_landing/step2" + location.search;
        history.push(offerPagePath, { from: 'saleslanding page' } );
        window.addToDataLayer({ event: "dtcSalesLandingBtnGetProtected" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL + "/app/sales_landing/step2" + location.search,
        });
    };

    return (
        <>
            <div id="howWeProtectSection" className="howWeProtectSection">
                <div id="testimonialSection" className="container-fluid sales-landing-section">
                    <Testimonial />
                </div>

                <div className="container protect-section-textwall">
                    <div className="row protect-you-container">
                        <h4>How We Protect You</h4>
                        <div></div>
                        <p>
                            IdentityForce delivers ongoing monitoring, rapid alerts, and recovery services to help protect against ID theft. Recognized as the 2017
                            Gold Stevie Award for best new product, along with the 2017 People's Choice Stevie Award for favorite product, you can rest easy knowing
                            we have proven identity, privacy, and credit security solutions. We combined advanced detection technology, real-time alerts, 24/7
                            support, and identity recovery with 40 years of experience to get the job done.
                        </p>
                    </div>

                    <div className="row protect-you-section">
                        <div className="col-sm-6 section-image">
                            <img role="option" src={require("../../Assets/images/funnel/sales/monitor-icon.png").default} alt="Monitor Icon" />
                        </div>
                        <div className="col-sm-6 protect-blurb">
                            <h4>Monitor</h4>
                            <div></div>
                            <p>
                                IdentityForce is always vigilant. We keep our eyes on your identity, privacy, and credit by using innovative identity theft
                                protection technology that allows us to be proactive. In order to detect the illegal selling of your personal, financial, and credit
                                information, IdentityForce delivers broader coverage—the kind of full spectrum monitoring your personal information needs these
                                days.
                            </p>
                        </div>
                    </div>

                    <div className="row protect-you-section">
                        <div className="col-md-6 protect-blurb">
                            <h4>Alert</h4>
                            <div></div>
                            <p>
                                IdentityForce provides an early warning system with instant notification when your personal information is at risk. With
                                IdentityForce's prompt alerts sent to your smart phone, tablet, or computer, you have the power to act before any damage is done.
                            </p>
                        </div>
                        <div className="col-md-6 section-image">
                            <img role="option" src={require("../../Assets/images/funnel/sales/alert-icon.png").default} style={{ float: "left" }} alt="Alert Icon" />
                        </div>
                    </div>

                    <div className="row protect-you-section">
                        <div className="col-sm-6 section-image">
                            <img role="option" src={require("../../Assets/images/funnel/sales/control-icon.png").default} alt="Control Icon" />
                        </div>
                        <div className="col-sm-6 protect-blurb">
                            <h4>Control</h4>
                            <div></div>
                            <p>
                                Knowledge is power! Take control by understanding your credit score, and where or how your online information is being used. Protect
                                your keystrokes, pin numbers, and credit card information. When you know what's at risk, you can be sure you have the protection you
                                need. And when you want total control, count on IdentityForce to get it done.
                            </p>
                        </div>
                    </div>

                    <div className="row protect-you-section">
                        <div className="col-md-6 protect-blurb">
                            <h4>Recover</h4>
                            <div></div>
                            <p>
                                IdentityForce's Certified Protection Experts offer comprehensive, 24/7 recovery services. We can save you literally hundreds of
                                hours by completing all the paperwork, making the calls, and handling every detail to ensure your identity is restored. We've got
                                your back, and you're covered by our nationwide $1 million Identity Theft insurance policy.
                            </p>
                        </div>
                        <div className="col-md-6 section-image">
                            <img role="option" src={require("../../Assets/images/funnel/sales/blue-idcard.png").default} style={{ float: "left" }} alt="Recover Icon" />
                        </div>
                    </div>

                    <div className="getProtectedButton2Wrapper">
                        <p>
                            <button className="btn-default btn-primary btn-md btn-sm get-protected protected-button" onClick={routeToOfferPage} type="button">
                                <span>GET PROTECTED</span>
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HowWeProtect;
